<script lang="ts">
	//Services
	import { format } from 'svelte-i18n';
	// import { postReq } from '../../services/http';
	//Store
	import { devices } from 'src/stores/lists/devices';
import { rooms } from 'src/stores/lists/rooms';
import { alarms } from 'src/stores/lists/scenes-derived';
	// import { scenes } from 'src/stores/lists/scenes';
	//Helpers
	import { load_image_from } from '../../helpers/interface_helpers';
	import { _deepClone } from '../../helpers/utilities';
	import { copy } from '../../helpers/copy_text';
	import { buildAlarmRoomsWithSensors } from '../Lists/list-helpers';
	//Design System
	import {
		ControlsContainer,
		DrawerTabs,
		DrawerTab,
		DrawerTabContent,
		// DeviceButton,
		Text,
		IconButton,
		Stack,
		ParameterCard,
		AdvancedCard,
		LabelList,
	} from '@Shelly/shelly-design-system';
	//Components
	import DeviceInList from '../Lists/Devices/DeviceInList.svelte';
	import AlarmWizard from '../AlarmZones/AlarmWizard/AlarmWizard.svelte';
	import EventLog from '../EventLog/EventLog.svelte';
	// import PinUnlock from '../PinUnlock.svelte';
	import ControlAlarm from '../Lists/Alarms/ControlAlarm.svelte';
	import TimerAlarmDelay from '../Lists/Alarms/components/TimerAlarmDelay.svelte';

	//TODO remove commented prev implementation for alarm controls after QA test validates ControlAlarm, handles all cases
	import PinUnlock from '../PinUnlock.svelte';
	import { hasAlarmControlRights, isSubAccount } from 'src/helpers/user_helpers';
	import { sidePanelStateCombined } from 'src/stores/ui/sidepanel-public';

	let id = $sidePanelStateCombined?.id;
	$: alarm = $alarms[id];
	let roomsWithSensors = [];
	let missingDevices = [];
	let hasPresence = false;
	let activeTab = 0;
	let showAddEditAlarmModal = false;
	/**
	 * Snapshot of the alarm taken at the moment the edit modal is opened.
	 * Using a one-time deep clone prevents $alarms store polling from overwriting
	 * in-progress edits inside AlarmWizard.
	 */
	let editAlarmObject = null;
	// let showPinLockModal = false;
	let showDelayModal = false;

	const hasAlarmRights = hasAlarmControlRights(alarm);

	$: isAlarmEnabled = typeof $alarms[id] !== 'undefined' ? $alarms[id]._enabled : alarm._enabled;
	$: drawerTabs = alarm
		? [
				{
					image: alarm?._meta?.image ? load_image_from(alarm?._meta?.image) : undefined,
					backgroundColor: alarm?._meta?.backgroundColor,
				},
				{ icon: 'fal fa-microchip' },
				{ icon: 'fal fa-notebook' },
				{ icon: 'fal fa-info-circle' },
			]
		: [{ icon: 'fal fa-trash' }];

	$: if (alarm) {
		({ roomsWithSensors, missingDevices, hasPresence } = buildAlarmRoomsWithSensors(
			alarm,
			$devices,
			$rooms,
		));
	}

	$: textUnderDeviceButtonTranslation = alarm
		? isAlarmEnabled
			? $format('label_action_alarm_disarm', { default: 'Disarm' })
			: $format('label_action_alarm_arm', { default: 'Arm' })
		: '';

	// const toggle_arm_state = () => {
	// 	if (alarm.pin_lock) {
	// 		showPinLockModal = true;
	// 	} else {
	// 		handleUnlock();
	// 	}
	// };

	// async function handleUnlock() {
	// 	try {
	// 		let edited: any = _deepClone(alarm);
	// 		edited._enabled = !isAlarmEnabled;
	// 		// Maybe we should update and in the drawer
	// 		if (edited._enabled && edited._enable_delay) {
	// 			edited._meta._time_trigger = Date.now();
	// 		}
	// 		const res = await postReq('/scene/edit', {
	// 			id,
	// 			scene_script: JSON.stringify(edited),
	// 		});
	// 		if (res.isok) {
	// 			scenes.editScene(edited);
	// 		}
	// 	} catch (error) {
	// 		console.log('error on arm/disarm ', error);
	// 	}
	// }

	// function handleClose() {
	// 	showPinLockModal = false;
	// }
</script>

<DrawerTabs backgroundImgSrc="">
	<svelte:fragment slot="tabs">
		{#key activeTab}
			{#each drawerTabs as drawerTab, ind}
				<DrawerTab
					active={activeTab === ind}
					image={drawerTab.image}
					backgroundColor={drawerTab.backgroundColor}
					icon={drawerTab.icon
						? activeTab === ind
							? `${drawerTab.icon} text-primary`
							: drawerTab.icon
						: undefined}
					on:click={() => (activeTab = ind)}
				/>
			{/each}
		{/key}
	</svelte:fragment>
	{#key activeTab}
		{#if typeof alarm === 'object'}
			<DrawerTabContent
				heading={alarm._meta.name}
				subHeading={$format('settings_title_main_controls', {
					default: 'Main controls',
				})}
			>
				<!-- {#if alarm} -->
				<svelte:fragment slot="headingButton">
					{#if !isSubAccount()}
						<IconButton
							aria-label={$format('button_open_edit_alarm_modal', {
								default: 'Button open edit alarm modal',
							})}
							icon="fas fa-pen"
							on:click={() => {
								editAlarmObject = _deepClone(alarm);
								showAddEditAlarmModal = true;
							}}
						/>
					{/if}
				</svelte:fragment>
				<!-- {/if} -->
				{#if activeTab === 0}
					<div class="flex-full-height" />

					<ControlsContainer>
						<div slot="first">
							<!-- <DeviceButton
								class="justify-content-center"
								isWide
								size="l"
								indicator={isAlarmEnabled ? 'on' : 'off'}
								icon="fas fa-shield"
								variant="primary"
								isActive={isAlarmEnabled}
								disabled={!hasAlarmRights}
								on:click={() => toggle_arm_state()}
							/> -->
							<ControlAlarm
								item={$alarms[id]}
								isOnDrawer
								on:alarmDelayStart={(e) => {
									showDelayModal = true;
								}}
							/>

							<TimerAlarmDelay
								alarm={$alarms[id]}
								hideLabel
								bind:showModal={showDelayModal}
							/>

							<Text styleType="controls-large" class="mt-s text-bold">
								{textUnderDeviceButtonTranslation}
							</Text>
						</div>
					</ControlsContainer>
				{:else if activeTab === 1}
					<Stack gap="s">
						{#if missingDevices.length}
							{#each missingDevices as device, ind}
								<AdvancedCard
									isCondensed
									title={$format('missing_device_label', {
										default: 'Missing Device',
									})}
									avatar={{
										icon: 'text-warning fas fa-warning',
									}}
								>
									<svelte:fragment slot="main">
										<LabelList
											labelList={[
												{ value: device.id, icon: 'fa-solid fa-microchip' },
											]}
										/>
									</svelte:fragment>
								</AdvancedCard>
							{/each}
						{/if}

						{#each roomsWithSensors as room, ind}
							{#if room.devices}
								{#each room.devices as device}
									<DeviceInList {device} type="group" variant="condensed" />
									{#if hasPresence && device._alarmZoneLabel}
										<LabelList
											size="s"
											labelList={[
												{
													value: device._alarmZoneLabel,
													icon: 'fa fa-vector-square',
												},
											]}
										/>
									{/if}
								{/each}
							{/if}
						{/each}
					</Stack>
				{:else if activeTab === 2}
					<EventLog device={alarm} type={'device'} />
				{:else if activeTab === 3}
					<ControlsContainer class="mt-m" size="s">
						<svelte:fragment slot="first">
							<Text
								styleType="body-small"
								class="text-bold align-self-center text-capitalize text-left"
							>
								{$format('alarm_zone_id', { default: 'Alarm zone id' })}
							</Text>
							<hr class="mt-s mb-s" />
							<div class="d-flex justify-content-between align-items-center">
								<Text class="text-break-all" styleType="body-small">{id}</Text>

								<IconButton
									aria-label={$format('button_copy_alarm_id', {
										default: 'Copy alarm ID',
									})}
									class="ml-s"
									icon="fas fa-copy"
									on:click={() =>
										copy(
											id,
											$format('copied_successfully', {
												default: 'Copied successfully!',
											}),
										)}
								/>
							</div>
						</svelte:fragment>
					</ControlsContainer>
				{/if}
			</DrawerTabContent>
		{:else}
			<DrawerTabContent heading={$format('title_deleted_alarm', { default: 'Deleted alarm' })}>
				<div class="flex-full-height" />
				<ParameterCard
					icon="fas fa-shield-halved"
					title={$format('label_not_found_el', {
						default: 'Not found element',
					})}
					description={'ID:' + id}
					size="m"
				/>
			</DrawerTabContent>
		{/if}
	{/key}
</DrawerTabs>

{#if showAddEditAlarmModal && editAlarmObject}
	<AlarmWizard
		{id}
		bind:showAddEditAlarmModal
		alarm_object={editAlarmObject}
		on:close={() => (editAlarmObject = null)}
	/>
{/if}

<!-- {#if showPinLockModal}
	<PinUnlock
		bind:showModal={showPinLockModal}
		on:close={handleClose}
		on:unlock={handleUnlock}
	/>
{/if} -->
